import { useEffect } from "react";
import { toast } from "sonner";
import { Gauge } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

// Gently offers Low-data mode when we detect a slow/metered connection.
// Shows once per browser (until dismissed) and never nags.
export function DataSaverPrompt() {
  const { lowData, setLowData } = useSettings();

  useEffect(() => {
    if (lowData) return;
    if (localStorage.getItem("pula_lowdata_prompted") === "1") return;

    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return;
    const slow = conn.saveData === true || ["slow-2g", "2g"].includes(conn.effectiveType);
    if (!slow) return;

    localStorage.setItem("pula_lowdata_prompted", "1");
    const t = setTimeout(() => {
      toast("Slow connection detected", {
        description: "Turn on Low-data mode to save data — images load lighter and video is paused.",
        icon: <Gauge className="w-4 h-4 text-pula-green" />,
        duration: 12000,
        action: {
          label: "Turn on",
          onClick: () => setLowData(true),
        },
      });
    }, 2500);
    return () => clearTimeout(t);
  }, [lowData, setLowData]);

  return null;
}
